module.exports = __webpack_public_path__ + "static/xero-096405b7ea0ae65d82932024459bdd2e.svg";